const observer = new MutationObserver(() => {
    const elements = document.querySelectorAll(".slidecarthq-overlay, .slidecarthq header, .slidecarthq footer, .jdgm-prev-badge__stars");

    elements.forEach(el => {
        el.removeAttribute("tabindex");
        el.removeAttribute("aria-label");
        el.setAttribute("role", "presentation");
    });

    const headers = document.querySelectorAll('header.upsell-options-header');
    if (headers.length) {
        headers.forEach(el => {
            el.setAttribute('role', 'presentation');
        });
    }
   const slidecart = document.getElementById('slidecarthq');
if (slidecart && slidecart.parentNode && slidecart.parentNode.nodeType === 1) { // Ensure parent is element
    const parentTag = slidecart.parentNode.tagName.toLowerCase();
    if (parentTag !== 'section') {
        const section = document.createElement('section');
        section.setAttribute('aria-label', 'Shopping Cart Panel'); 
        slidecart.parentNode.insertBefore(section, slidecart);
        section.appendChild(slidecart);
    }
}

    const quantityInputs = document.querySelectorAll('.slidecarthq .quantity-selector input[type="text"]');
    quantityInputs.forEach((input, index) => {
        if (!input.id) {
            input.id = `slidecart-quantity-${index + 1}`;
        }
        if (!document.querySelector(`label[for="${input.id}"]`)) {
            const label = document.createElement('label');
            label.className = 'visually-hidden';
            label.textContent = 'Quantity';
            label.setAttribute('for', input.id);
            input.parentNode.insertBefore(label, input);
        }
    });
    const getSelectOptions = document.querySelectorAll('.slidecarthq .upsell-options .option select');
    getSelectOptions.forEach(select => {
        select.setAttribute('aria-label', 'Choose size');
    });
    
    if (slidecart && elements.length && headers.length && quantityInputs.length && getSelectOptions.length) {
        observer.disconnect();
    }
});

observer.observe(document.body, {
    childList: true,
    subtree: true
});

document.addEventListener("DOMContentLoaded", function () {
    const fixClonedSlides = () => {
        const hiddenSlides = document.querySelectorAll('[aria-hidden="true"]');
        hiddenSlides.forEach(slide => {
            const focusableItems = slide.querySelectorAll('[tabindex="0"]');
            focusableItems.forEach(el => {
                el.removeAttribute('tabindex');
            });
        });
    };
    fixClonedSlides();
    document.querySelectorAll('.slider_wrap_wine .jdgm-prev-badge__stars').forEach(slider => {
        slider.addEventListener('afterChange', fixClonedSlides);
    });
    const section = document.querySelector('#shopify-section-footer-logos');
    if (section && !section.hasAttribute('aria-label')) {
        section.setAttribute('aria-label', 'Footer brand logos');
    }

    
// change h5 to h4 in product faq accordion
    const container = document.querySelector("#accordionproductsFaq");
  if (!container) return;

  const headings = container.querySelectorAll("h5");
  headings.forEach(h5 => {
    const h4 = document.createElement("h4");
    h4.innerHTML = h5.innerHTML;

    for (const { name, value } of h5.attributes) {
      h4.setAttribute(name, value);
    }

    h5.replaceWith(h4);
  });
});
document.addEventListener("DOMContentLoaded", () => {
  const slides = document.querySelectorAll(".related-products-slider .prod_cards");

  // Function to update tabindex for slide and its focusable elements
  function updateSlideFocus(slide) {
    const focusableSelectors = 'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])';
    if (slide.getAttribute("aria-hidden") === "true") {
      slide.setAttribute("tabindex", "-1");

      // Disable focus on inner elements
      slide.querySelectorAll(focusableSelectors).forEach(el => {
        el.setAttribute("data-orig-tabindex", el.getAttribute("tabindex") || "0");
        el.setAttribute("tabindex", "-1");
      });
    } else {
      slide.setAttribute("tabindex", slide.getAttribute("data-orig-tabindex") || "0");

      // Restore focus on inner elements
      slide.querySelectorAll(focusableSelectors).forEach(el => {
        el.setAttribute("tabindex", el.getAttribute("data-orig-tabindex") || "0");
      });
    }
  }

  // Initial update
  slides.forEach(slide => updateSlideFocus(slide));

  // Observe dynamic changes to aria-hidden
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.type === "attributes" && mutation.attributeName === "aria-hidden") {
        updateSlideFocus(mutation.target);
      }
    });
  });

  slides.forEach(slide => observer.observe(slide, { attributes: true }));
});

